import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToolbarModule } from '../public/toolbar/toolbar.module';
import { FrequentQuestionsComponent } from './frequent-questions.component';
import { NewFooterModule } from '../public/new-footer/new-footer.module';

@NgModule({
  declarations: [FrequentQuestionsComponent],
  exports: [FrequentQuestionsComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: FrequentQuestionsComponent
      }
    ]),
    ToolbarModule,
    NewFooterModule
  ]
})
export class FrequentQuestionsModule {}
